;(function () {
  'use strict'

  angular.module('contrast.survey').factory('SurveyService', SurveyService)

  function SurveyService(
    $routeSegment,
    $q,
    $window,
    $location,
    $uibModal,
    $document,
    ServiceUtils,
    UserFactory,
    UserService,
    permissions,
    SURVEY_STATES
  ) {
    'ngInject'

    var activeDateRange = {
      start: moment('2017-04-03T00:00:00+00:00', moment.ISO_8601)
    }

    activeDateRange.end = moment(activeDateRange.start, moment.ISO_8601).add(
      60,
      'days'
    )

    var _surveyUrl = 'https://contrastsecurity.typeform.com/to/sFMuOb'
    var _surveyWindowName = 'contrastSecuritySurvey'
    var _state

    var service = {
      init: init,
      open: open,
      isPending: isPending,
      setDeclined: setDeclined,
      setCompleted: setCompleted,
      launchSurvey: launchSurvey
    }

    return service

    function init() {
      return _getOrg()
        .then(_getState)
        .then(function (state) {
          _state = state
        })
        .catch(ServiceUtils.handleError)
    }

    function _getOrg() {
      if (UserService.getCurrentOrganization() === null) {
        return permissions.getDefaultOrganization()
      }
      return $q.when()
    }

    function _getState() {
      return UserFactory.getSurveyState()
        .then(ServiceUtils.handleResolve('data.state'))
        .catch(ServiceUtils.handleError)
    }

    function isPending() {
      var promise = !_state ? init() : $q.when()
      return promise.then(function () {
        return angular.isString(_state) && _state === SURVEY_STATES.PENDING
      })
    }

    function open() {
      return $uibModal.open({
        templateUrl: 'views/survey/index.html',
        controller: 'SurveyModalCtrl',
        windowClass: 'tsv-setup-dialog survey-ad',
        appendTo: $document.find('aside'),
        backdrop: false,
        keyboard: false
      })
    }

    function setDeclined() {
      return UserFactory.updateSurveyState(SURVEY_STATES.DECLINED)
        .then(_finish)
        .catch(ServiceUtils.handleError)
    }

    function setCompleted() {
      return UserFactory.updateSurveyState(SURVEY_STATES.COMPLETED)
        .then(_launchSurvey)
        .then(_finish)
        .catch(ServiceUtils.handleError)
    }

    function _launchSurvey() {
      $window.open(_surveyUrl, _surveyWindowName)
    }

    function _finish() {
      $location.path(UserService.buildUrl('/dashboard'), true)
      init()
    }

    function launchSurvey() {
      return isPending().then(function (isPending) {
        if (
          _isActive() &&
          isPending &&
          !permissions.isImpersonating() &&
          $routeSegment.name.indexOf('survey') < 0
        ) {
          $location.path(UserService.buildUrl('/survey'))
        }
      })
    }

    function _isActive() {
      var now = moment()
      var start = activeDateRange.start
      var end = activeDateRange.end
      return now.isAfter(start) && now.isBefore(end)
    }
  }
})()
